import { render, staticRenderFns } from "./kyc-certification.vue?vue&type=template&id=1c55dd2c&scoped=true&"
import script from "./kyc-certification.vue?vue&type=script&lang=js&"
export * from "./kyc-certification.vue?vue&type=script&lang=js&"
import style0 from "./kyc-certification.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./kyc-certification.vue?vue&type=style&index=1&id=1c55dd2c&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1c55dd2c",
  null
  
)

export default component.exports